module.exports = __webpack_public_path__ + "img/image6.58b9fc07.png";